import { Box } from '@mui/material';
import { GuestJourneyKpiCard } from 'api/reports-service/guest-journey-reports.types';
import KpiCard from '../kpi-card/kpi-card.component';

export type BenchmarksKpiCardsProps = {
  /**
   * FE-built "Brand Cuisine" card, always rendered first (its value comes from
   * the bootstrap, not the query, so it never shows a loading skeleton).
   */
  leadingCard?: GuestJourneyKpiCard;
  /** BE-ordered, pre-formatted KPI cards from `GET benchmarks/overview` (v0.5). */
  cards?: GuestJourneyKpiCard[];
  loading?: boolean;
};

// The BE owns card order and content (spec v0.5 — three cards: Frequency Median,
// Frequency Quartile, Churn Threshold); render them in array order. While
// loading the array is empty, so show three placeholder cards to hold the grid.
const LOADING_PLACEHOLDERS = 3;

const BenchmarksKpiCards = ({
  leadingCard,
  cards,
  loading = false,
}: BenchmarksKpiCardsProps) => {
  const items =
    loading && !cards?.length
      ? Array.from({ length: LOADING_PLACEHOLDERS }, () => undefined)
      : cards ?? [];

  return (
    <Box
      display="grid"
      gap={2}
      gridTemplateColumns={{
        xs: '1fr',
        md: 'repeat(2, 1fr)',
        lg: 'repeat(4, 1fr)',
      }}
      data-testid="Benchmarks.KpiCards"
    >
      {leadingCard && (
        <KpiCard
          key="brand-cuisine"
          card={leadingCard}
          loading={false}
          data-testid="Benchmarks.KpiCard.BrandCuisine"
        />
      )}
      {items.map((card, index) => (
        <KpiCard
          key={card?.title ?? index}
          card={card}
          loading={loading}
          data-testid={`Benchmarks.KpiCard.${index}`}
        />
      ))}
    </Box>
  );
};

export default BenchmarksKpiCards;
